//Frontend/src/unicodex_ui/services/portalInventoryApi.js
import api from "./apiClient";

const portalInventoryApi = {
  async listBranches() {
    const res = await api.get("/api/inventory/branches");
    return res.data;
  },
  async listLocations(branchId) {
    const res = await api.get("/api/inventory/locations", { params: { branchId } });
    return res.data;
  },
  async listStockLevels(params) {
    const res = await api.get("/api/inventory/stock-levels", { params });
    return res.data;
  },
  async listStockMovements(params) {
    const res = await api.get("/api/inventory/stock-movements", { params });
    return res.data;
  },
  async adjustStock(payload) {
    const res = await api.post("/api/inventory/stock/adjust", payload);
    return res.data;
  },
  async receiveManufactured(payload) {
    const res = await api.post("/api/inventory/stock/receive-manufactured", payload);
    return res.data;
  },

  async listReceivableBatches(params) {
    const res = await api.get("/api/inventory/receivable-batches", { params });
    return res.data;
  },
};

export default portalInventoryApi;
